import { StyleSheet } from 'react-native';
import { rem } from 'design-system/values';
import { isIOS, isWeb } from '../constants';
export const TAB_SCREEN_HEADER_HEIGHT = rem(60);
export const TAB_SCREEN_HEADER_HEIGHT_WEB = 64;
// eslint-disable-next-line no-nested-ternary
export const HEADER_WITH_SUBTITLE_HEIGHT = isWeb ? undefined : isIOS ? 46 : 60;
export const navigatorStyle = StyleSheet.create({
    title: {
        fontFamily: 'Montserrat-Regular',
        fontSize: rem(18),
        lineHeight: rem(18 * 1.1),
        fontWeight: null,
        textAlign: 'center',
        marginHorizontal: 8,
    },
});
